import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { SportService } from '@app/core/services';
import { CommonService } from '@app/core/services/common.service';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-upcoming-general',
  templateUrl: './upcoming-general.component.html',
  styleUrls: ['./upcoming-general.component.scss'],
})
export class UpcomingGeneralComponent implements OnInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  games: any[] = [];
  allgames: any;
  selectedGame: any;
  selectedSport = '';
  date: any = null;
  upcoming = true;
  currentDate = formatDate(new Date(), 'YYYY-MM-dd', 'en');
  maxDate = new Date();
  hideLoadMore = false;
  @Output() onSelectGame = new EventEmitter();

  constructor(
    private _sport: SportService,
    public _common: CommonService,
    public _router: Router,
    public _activated: ActivatedRoute
  ) { }

  async ngOnInit() {
    this.hideLoadMore = this._router.url.search('expert-picks') != -1;
    this._activated.data.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.selectedSport = data['sport'] || this._sport.defaultSport;
      this.date = null;
      if (this._activated.snapshot.params['day']) {
        this.date = `${this._activated.snapshot.params['year']}-${this._activated.snapshot.params['month']}-${this._activated.snapshot.params['day']}`;
      }
      if (!this.date || formatDate(new Date(), 'YYYY-MM-dd', 'en') < this.date) {
        this.loadData(this.selectedSport);
      }
    });

    this._activated.params.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.selectedSport =
        this._activated.snapshot.data['sport'] || this._sport.defaultSport;
      this.date = null;
      if (data['day']) {
        this.date = `${data['year']}-${data['month']}-${data['day']}`;
      }
      if (this.date && formatDate(new Date(), 'YYYY-MM-dd', 'en') > this.date) {
        this.loadData(this.selectedSport, this.date);
      } else if (this.date) {
        this.loadData(this.selectedSport);
      }
    });
  }

  changeDate(event: MatDatepickerInputEvent<any>) {
    let date = formatDate(event.value, 'dd-MM-YYYY', 'en-us').split('-');
    this._router.navigate([
      this.selectedSport.toLowerCase(),
      'expert-picks',
      ...date,
    ]);
  }

  loadData(sport: string, date?: string) {
    // console.log(sport,date)
    this._sport.upcomingGeneral(sport, date).then((res) => {
      this.allgames = res;
      if (this.allgames?.live?.length || this.allgames?.upcoming?.length) {
        this.upcoming = this.allgames?.upcoming?.length ? true : false;
        if (
          !this._activated.snapshot.params['slug'] &&
          this._router.url.search('expert-picks') !== -1 &&
          this.allgames[this.upcoming ? 'upcoming' : 'live'][0]
        ) {
          let param = {
            slug: this.allgames[this.upcoming ? 'upcoming' : 'live'][0].slug,
            sport:
              this.allgames[
                this.upcoming ? 'upcoming' : 'live'
              ][0].sport.toLowerCase(),
            date: this.date,
          };
          this.selectedGame =
            this.allgames[this.upcoming ? 'upcoming' : 'live'][0].slug;
          if (this._common.isBrowser || this.date) {
            this.onSelectGame.next(param);
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
